module.exports = __webpack_public_path__ + "files/9e1901c68433940bd2e4d65095c35e0a.svg";